import type { Release } from '../releases.ts';

export default {
  version: '0.17.0',
  date: '2026-10-02',
  title: 'Live sources: RTMP and SRT',
  summary: [
    'Live sources: RTMP or SRT listeners that encoders and phone apps stream into',
    'Each stream becomes an asset recorded as received, with a live proxy',
    'The recording is processed like an upload when the stream ends',
    'A workflow step starts or stops a live source on a schedule',
    'Live recording runs on its own worker',
  ],
  features: [
    'Live sources (Administration → Live sources): RTMP or SRT listeners that an encoder or a phone app such as Larix Broadcaster streams straight into PRISM; storage managers set them up, anyone who may upload starts and stops them',
    'While a source is started, every stream that connects becomes an asset recorded exactly as received (MPEG-TS, no re-encoding), with a live proxy to watch about 6 to 10 seconds behind and metadata that can be entered while it records',
    'When the stream ends, or the source is stopped, the recording is processed like any upload; the source then listens for the next stream',
    'Phone app setup shows the server, stream key or passphrase to copy into the app',
    'New workflow step Live source (start or stop): with a schedule trigger and a Delay, PRISM records at set times',
    'Live recording runs on its own worker (live-worker in Compose, the live entry in Helm), so long recordings never hold up ingest',
  ],
  fixes: [],
} satisfies Release;
